export default {
  title: "Estamp Portal"
};
